module.exports = __webpack_public_path__ + "static/media/63.3a7dcc0.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/63.wav
// module id = oHgx
// module chunks = 0